import { useCallback, useEffect, useState } from 'react';
import { PlaidLinkOnExit, PlaidLinkOnSuccess, PlaidLinkStableEvent } from 'react-plaid-link';

import LoaderOverlay from 'components/PageLayout/LoaderOverlay';
import PlaidWidget from 'components/curo-components/plaid/PlaidWidget';
import useDispatchWithUnwrap from 'hooks/useDispatchWithUnwrap';
import { getPlaidLinkToken, plaidSavePublicToken } from 'thunks';

interface IBankInformationStepProps {
  onStepExit: () => void;
  onStepComplete: () => void;
  onStepFailed: () => void;
}

const BankInformationPlaidStep = ({
  onStepExit,
  onStepComplete,
  onStepFailed,
}: IBankInformationStepProps) => {
  const [linkToken, setLinkToken] = useState<string | null>(null);
  const dispatchWithUnwrap = useDispatchWithUnwrap();

  const getLinkToken = async () => {
    const { linkToken: plaidLinkToken } = await dispatchWithUnwrap(getPlaidLinkToken());

    if (plaidLinkToken) {
      setLinkToken(plaidLinkToken);
    }
  };

  const onSuccess: PlaidLinkOnSuccess = useCallback(async (token) => {
    await dispatchWithUnwrap(plaidSavePublicToken(token));
    onStepComplete();
  }, []);

  const onExit: PlaidLinkOnExit = useCallback(() => {
    onStepExit();
  }, []);

  const onEvent = useCallback((eventName: PlaidLinkStableEvent | string) => {
    if (eventName === PlaidLinkStableEvent.ERROR) {
      onStepFailed();
    }
  }, []);

  useEffect(() => {
    getLinkToken();
  }, []);

  if (!linkToken) {
    return <LoaderOverlay />;
  }

  return (
    <PlaidWidget
      onEventAction={onEvent}
      onExitAction={onExit}
      onSuccessAction={onSuccess}
      linkToken={linkToken}
    />
  );
};

export default BankInformationPlaidStep;
